import { Outlet, Navigate } from 'react-router';
import {useFirebaseAuth} from './context/AuthContext.js';

const ProtectedRoute = () => {
  const a = useFirebaseAuth();
  return  a ? <Outlet /> : <Navigate to='/' />;
}

export default ProtectedRoute